import { Controller } from '@hotwired/stimulus'
import { bindDayToggle } from '../shared/shared_report_chart'

export default class extends Controller {
  connect() {
    bindDayToggle(this.element)
  }
}
